import React from "react";
import { useTranslation } from "react-i18next";
import {LoadingSpinner} from "shared/assets/svgs/LoadingSpinner";

type Props = {
  spinning?: boolean;
  fullscreen?: boolean;
  size?: "small" | "default" | "large";
  children?: React.ReactNode;
}

export function PopupSpinner({
                       spinning = true,
                       fullscreen = true,
                       children,
                     }: Props) {
  const { t } = useTranslation("common");
  if (!spinning) return children ?? null;
  
  if (fullscreen) {
    return (
      <div className="fixed inset-0 z-[9999] flex flex-col gap-4 items-center justify-center bg-white/70 backdrop-blur-[1px]">
        <LoadingSpinner/>
      </div>
    );
  }
  
  return (
    <div className="relative inline-flex items-center justify-center">
      <div className="text-neutral-900 text-sm">{t("Loading... Please wait.")}</div>
      <div className={"absolute inset-0 flex items-center justify-center"}>
        <LoadingSpinner/>
      </div>
    </div>
  );
}
